export const track = (event, data) => {
  data.event = event;
  if(window?.dataLayer?.push) window.dataLayer.push(data);
}

export const trackError = (error) => {
  const data = {event:'formError', error:error};
  if(window?.dataLayer?.push) window.dataLayer.push(data);
}
